// removed by extract-text-webpack-plugin
module.exports = {"inlineBtn":"InlineButton_inlineBtn_2GlKm"};